import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import WebviewNotice from './components/WebviewNotice';
import { captureAttribution } from './lib/tracking-url';
import './index.css';

// Persist first-touch utm_*/gclid/fbclid before any client-side navigation strips
// them, so the cross-domain CTA to app.neosearch.neobim.ai keeps attribution.
captureAttribution();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WebviewNotice />
    <App />
  </StrictMode>
);
